class ExpressionHarness {
  declare preamble: string;

  constructor({ preamble }: { preamble: string }) {
    this.preamble = preamble;
  }
}

export default ExpressionHarness;
